const getGstAmount = (
  amount: number | string,
  percentage: number | string,
  type: "inclusive" | "exclusive",
) => {
  if (type == "exclusive") {
    return (Number(amount) * Number(percentage)) / 100;
  } else {
    return (Number(amount) * Number(percentage)) / (100 + Number(percentage));
  }
};

const getWithGstAmount = (
  amount: number | string,
  percentage: number | string,
) => {
  return Number(amount) + getGstAmount(amount, percentage, "exclusive");
};

const getWithoutGstAmount = (
  amount: number | string,
  percentage: number | string,
) => {
  return Number(amount) - getGstAmount(amount, percentage, "inclusive");
};

export { getGstAmount, getWithGstAmount, getWithoutGstAmount };
